export const SAGA_AUTH_SIGN_IN = 'SAGA_AUTH_SIGN_IN';

export function signIn(credentials){
    return {
        type: SAGA_AUTH_SIGN_IN,
        payload: {
            credentials:{
                username: credentials.username,
                password: credentials.password,
            },
        }        
    }
}


// WEBPACK FOOTER //
// ./src/auth/actions.js